<script setup lang="ts">
import { defineProps, defineEmits, computed, withDefaults } from "vue";

const props = withDefaults(
  defineProps<{
    filter: any;
    activeValue: any;
    mode?: "normal" | "small";
  }>(),
  {
    filter: () => ({}),
    activeValue: false,
    mode: "normal",
  }
);

const emit = defineEmits<{
  (e: "update", value: any): void;
}>();

const valuesArray = computed(() => {
  return Object.entries(props.filter.values || {}).map(([val, label]) => ({
    val,
    label,
  }));
});

const activeIndex = computed(() => {
  return valuesArray.value.findIndex(({ val }) => {
    if (props.filter.type === 'bool') {
      return Boolean(props.activeValue) === (val === 'true' || val === true);
    }
    return String(props.activeValue) === String(val);
  });
});

const sliderStyle = computed(() => {
  const count = valuesArray.value.length;
  if (count === 0 || activeIndex.value === -1) return { display: 'none' };
  
  const width = 100 / count;
  const left = activeIndex.value * width;
  
  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});
</script>

<template>
  <div class="flex items-center justify-center w-full">
    <div
        class="relative bg-gray-100 p-1 rounded-xl flex w-full shadow-inner"
        :class="mode === 'small' ? 'max-w-xs' : 'max-w-2xl'"
    >
      <!-- Sliding Background -->
      <div
        class="absolute top-1 bottom-1 bg-white rounded-lg shadow-sm transition-all duration-300 ease-out transform"
        :style="sliderStyle"
      ></div>

      <!-- Buttons -->
      <button
        v-for="{ val, label } in valuesArray"
        :key="val"
        type="button"
        class="relative flex-1 flex cursor-pointer items-center justify-center gap-2 font-light transition-colors duration-200 z-10"
        :class="[
          (filter.type === 'bool' ? Boolean(activeValue) === (val === 'true' || val === true) : String(activeValue) === String(val) || (!activeValue && String(val) === ''))
            ? 'bg-brand-main rounded-lg text-white'
            : 'text-gray-500 hover:text-gray-700',
          mode === 'small' ? 'py-1 text-xs' : 'py-2.5 text-sm'
        ]"
        @click="emit('update', filter.type === 'bool' ? (val === 'true' || val === true) : val)"
      >
        {{ label }}
      </button>
    </div>
  </div>
</template>

<style scoped>
</style>